import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
} from './ReactiveState.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from './abstracts.mjs';
import { Rememberkif8023snbmn as Remember } from './Remember.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  set1ry2ssh8gkbcc as set,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  MutableValue2jbqb2a7km3rc as MutableValue,
} from './coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function mutableRemember(useLastWhileLoading, coroutineContext, initialValue) {
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().Unconfined_1 : coroutineContext;
  return MutableRemember().new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(true, useLastWhileLoading, coroutineContext, null, initialValue);
}
function startListening($this) {
  var tmp = $this;
  tmp.forget_1 = $this.remember_1.addListener_6y9mct_k$(() => {
    var tmp;
    if (!$this.overridden_1) {
      $this.set_state_wnfcx0_k$($this.remember_1.get_state_wc71uu_k$());
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  var currentRememberedState = $this.remember_1.get_state_wc71uu_k$();
  var tmp_0;
  if (!$this.overridden_1) {
    var tmp_1;
    if (!$this.useLastWhileLoading_1) {
      tmp_1 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
      var tmp_2;
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
      if (!equals(_ReactiveState___get_raw__impl__92ipya(currentRememberedState), InternalReactiveNotActive_instance)) {
        tmp_2 = !equals(_ReactiveState___get_raw__impl__92ipya(currentRememberedState), InternalReactiveNotReady_instance);
      } else {
        tmp_2 = false;
      }
      tmp_1 = tmp_2;
    }
    tmp_0 = tmp_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    $this.set_state_wnfcx0_k$(currentRememberedState);
  }
}
function stopListening($this) {
  var tmp0_safe_receiver = $this.forget_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.forget_1 = null;
}
var MutableRememberClass;
function MutableRemember() {
  if (MutableRememberClass === VOID) {
    class $ extends BaseReactive() {
      constructor(stopListeningWhenOverridden, useLastWhileLoading, coroutineContext, deactivationDelay, initialValue) {
        return new.target.new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(stopListeningWhenOverridden, useLastWhileLoading, coroutineContext, deactivationDelay, initialValue);
      }
      static new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(stopListeningWhenOverridden, useLastWhileLoading, coroutineContext, deactivationDelay, initialValue) {
        stopListeningWhenOverridden = stopListeningWhenOverridden === VOID ? true : stopListeningWhenOverridden;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().Unconfined_1 : coroutineContext;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        var $this = this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$();
        $this.stopListeningWhenOverridden_1 = stopListeningWhenOverridden;
        $this.useLastWhileLoading_1 = useLastWhileLoading;
        $this.overridden_1 = false;
        $this.remember_1 = Remember().new_com_lightningkite_reactive_core_Remember_5il1gz_k$(coroutineContext, $this.useLastWhileLoading_1, deactivationDelay, VOID, initialValue);
        $this.forget_1 = null;
        return $this;
      }
      set_state_wnfcx0_k$(value) {
        super.set_state_wnfcx0_k$(value);
      }
      get_state_wc71uu_k$() {
        if (!this.overridden_1 && this.forget_1 == null)
          return Companion_getInstance().notActive_1;
        return super.get_state_wc71uu_k$();
      }
      activate_yijg9v_k$() {
        if (!this.overridden_1 && this.forget_1 == null) {
          startListening(this);
        }
      }
      deactivate_pmdz1g_k$() {
        if (this.forget_1 == null)
          return Unit_instance;
        stopListening(this);
        if (!this.overridden_1 && !this.useLastWhileLoading_1) {
          this.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        }
      }
      valueSet_aujvv6_k$(value) {
        if (!this.overridden_1) {
          this.overridden_1 = true;
          if (this.stopListeningWhenOverridden_1) {
            stopListening(this);
          }
        }
        this.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(value));
      }
      reset_5u6xz3_k$() {
        if (this.overridden_1) {
          this.overridden_1 = false;
          if (this.stopListeningWhenOverridden_1) {
            startListening(this);
          }
          var currentSharedState = this.remember_1.get_state_wc71uu_k$();
          var tmp;
          if (!this.useLastWhileLoading_1) {
            tmp = true;
          } else {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_0;
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
            if (!equals(_ReactiveState___get_raw__impl__92ipya(currentSharedState), InternalReactiveNotActive_instance)) {
              tmp_0 = !equals(_ReactiveState___get_raw__impl__92ipya(currentSharedState), InternalReactiveNotReady_instance);
            } else {
              tmp_0 = false;
            }
            tmp = tmp_0;
          }
          if (tmp) {
            this.set_state_wnfcx0_k$(currentSharedState);
          }
        }
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).set_revjhg_k$ = set;
    initMetadataForClass($, 'MutableRemember', VOID, VOID, [MutableReactive(), MutableValue()], [1]);
    MutableRememberClass = $;
  }
  return MutableRememberClass;
}
//region block: exports
export {
  MutableRemember as MutableRememberyv35kz5kmml7,
  mutableRemember as mutableRemember1h6fyyolumj0o,
};
//endregion

//# sourceMappingURL=MutableRemember.mjs.map
